import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WelcomeComponent } from './components/user/welcome/welcome.component';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSliderModule } from '@angular/material/slider';
import { MatNativeDateModule, MatRippleModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox'; 
import { MatGridListModule } from '@angular/material/grid-list';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { TestSheetComponent,SecureDialog  } from './components/candidate/test-sheet/test-sheet.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserHomeComponent } from './components/user/user-home/user-home.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { LoginUserComponent } from './components/login-user/login-user.component';
import { LoginCandidateComponent } from './components/login-candidate/login-candidate.component';
import { CandidateHomeComponent} from './components/candidate/candidate-home/candidate-home.component';
import { Error404Component } from './components/error404/error404.component';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { CandidateCardComponent } from './components/user/candidate-card/candidate-card.component';
import { CanditatesSidenavComponent } from './components/user/canditates-sidenav/canditates-sidenav.component';
import { CandidatesComponent } from './components/user/candidates/candidates.component';
import { InstructionsComponent } from './components/candidate/instructions/instructions.component';
import { WebcamSnapshotModule } from './components/candidate/webcam-snapshot/webcam-snapshot.module';
import { TestViewerComponent } from './components/user/test-viewer/test-viewer.component';
import { TestCreatorComponent } from './components/user/test-creator/test-creator.component';
import { RecruiterCardComponent } from './components/user/recruiter-card/recruiter-card.component';
import { RecruiterSidenavComponent } from './components/user/recruiter-sidenav/recruiter-sidenav.component';
import { addRepeated } from './components/user/welcome/welcome.component';
//import { WebcamSnapshotComponent } from './components/candidate/webcam-snapshot/webcam-snapshot.component';

@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    TestSheetComponent,
    UserHomeComponent,
    LoginUserComponent,
    LoginCandidateComponent,
    CandidateHomeComponent,
    Error404Component,
    CandidateCardComponent,
    CanditatesSidenavComponent,
    CandidatesComponent,
    InstructionsComponent,
    SecureDialog,
    TestViewerComponent,
    TestCreatorComponent,
    RecruiterCardComponent,
    RecruiterSidenavComponent,
    addRepeated

  ],
  imports: [
    WebcamSnapshotModule,
    FormsModule,
    MatToolbarModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatRadioModule,
    MatButtonModule,
    MatSidenavModule,
    MatExpansionModule,
    MatListModule,
    MatTableModule,
    MatProgressBarModule,
    MatSliderModule,
    MatRippleModule,
    MatDialogModule,
    MatCheckboxModule,
    MatGridListModule,
    MatDatepickerModule,
    MatNativeDateModule 


  ],
  providers: [
    MatDatepickerModule, 
    {provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptorService,
    multi: true
  },
  {provide: MAT_DATE_LOCALE, useValue: 'es-mx'}],
  bootstrap: [AppComponent]
})
export class AppModule { }
